import { CompanyDataState } from '@store/companies/company.firestore.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { FIRESTORE_COLLECTION_COMPANIES } from '@store/firestore/allFirestoreCollections';

export const companyDataState = createFeatureSelector<CompanyDataState>(FIRESTORE_COLLECTION_COMPANIES);
